import styled from 'styled-components';
import { CloseButton as DCCloseButton } from '@rsos/components/capstone/DataCards/DataCards.styles';
import { Box, Text } from '@rsos/components/capstone/base';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';

export const PANE_HEADER_HEIGHT = 81;

export const PANE_WIDTH = 360;

export const StyledCallPane = styled.div`
  padding: 15px;
  width: ${PANE_WIDTH}px;
  border-right: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  @media (max-width: ${BP_LAPTOP}px) {
    width: 100%;
  }
  background-color: inherit;
`;

export const StyledHeader = styled(Box).attrs({
  position: 'relative',
  marginBottom: '15px',
})``;

export const StyledCallerID = styled(Text).attrs({
  color: 'panePrimaryText',
  fontWeight: 'bold',
})``;

export const StyledSource = styled(Text).attrs({
  color: 'secondaryText',
  size: 'xsmall',
})``;
export const StyledBackNavigation = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  color: 'secondaryText',
  cursor: `pointer`,
})``;
export const Tools = styled(Box)`
  position: relative;
`;

export const CloseButton = styled(DCCloseButton)`
  margin-left: 7px;
`;
